// Ready translated locale messages
export default {
  en: {
    message: {
      delete: 'Delete this field',
      duplicated: 'Field already exists',
      select: 'Select a Field',
      description: 'Description',
      fieldLabel: 'Field Label',
      fieldKey: 'Field Key',
      fieldFilter: 'Type to filter a field',
      empty: 'Can be empty',
      cancel: 'Cancel',
      add: 'Add',
      addField: 'Add Custom Field'

    }
  },
  es: {
    message: {
      delete: 'Borrar el campo',
      duplicated: 'El campo ya existe',
      select: 'Nuevo campo',
      description: 'Descripcion',
      fieldLabel: 'Label',
      fieldKey: 'Key',
      fieldFilter: 'Filtrar campos',
      empty: 'Puede dejarse vacio',
      cancel: 'Cancelar',
      add: 'Agregar',
      addField: 'Agregar Nuevo Campo'
    }
  },
}
